export default "__VITE_ASSET__lXVDlAB9__"